module.exports = __webpack_public_path__ + "static/media/triangle.092d441a.svg";